import "core-js/modules/es.array.push.js";
import Tool from '@/assets/js/utils.js';
import { mapState } from 'vuex';
import $store from '@/store/index.js';
export default {
  data() {
    return {
      asParticipants: false,
      partyCode: '',
      env: '',
      participateUrl: '',
      participateChannelMode: {
        0: 'party',
        1: 'channel',
        2: 'reporter',
        4: 'arena',
        12: 'commentator',
        13: 'kiosk',
        18: 'intercom'
      },
      channelMode: {
        0: 'party',
        1: 'group',
        2: 'coordinator',
        4: 'arena',
        12: 'commentator',
        13: 'kiosk',
        18: 'intercom'
      },
      password: '',
      Parser: require('@/assets/js/us.js'),
      model: ''
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      Config: state => state.config,
      CheckEnv: state => state.checkEnv
    })
  },
  async created() {
    var _this$Config, _this$Config2;
    // alert(2)
    const parserObj = this.Parser && new this.Parser();
    await $store.dispatch('config');
    // 获取partyCode
    const {
      join_id,
      passWord,
      asParticipants,
      moveParticipants,
      model
    } = this.$route.query;
    this.asParticipants = asParticipants;
    this.model = model;
    const join_idRaw = join_id ? join_id.replace(/[^0-9]/ig, '') : '';
    const joinId = [18, 24, 32].includes(join_idRaw.length) ? Tool.removeDuplicateSegments(join_idRaw, join_idRaw.length) : join_idRaw;
    this.partyCode = joinId;
    this.password = passWord;
    const type = await this.$store.dispatch('checkEnv', {
      partyCode: this.partyCode
    });
    if (type === 'redirect') return;
    this.isWindows = parserObj && parserObj.getOS().name === 'Windows';
    this.isAndroid = parserObj && parserObj.getOS().name === 'Android';
    this.isMac = parserObj && parserObj.getOS().name === 'Mac OS';
    this.isLinux = /Linux/i.test(navigator.userAgent);
    this.State.isMac = this.isMac;
    this.State.isAndroid = this.isAndroid;
    const isMacWindows = navigator.userAgent.includes('CrOS');
    // partyline与会者链接
    this.participateUrl = `${location.protocol}//${location.host}/partyline/participate/${this.participateChannelMode[this.CheckEnv.channelModel]}?id=${this.partyCode}${(_this$Config = this.Config) !== null && _this$Config !== void 0 && _this$Config.apiEnv ? `&env=${(_this$Config2 = this.Config) === null || _this$Config2 === void 0 ? void 0 : _this$Config2.apiEnv}` : ''}`;
    // 判断用户登录了没有
    const hasLogin = this.State.hasLogin;
    // 获取router信息
    if (type === 'notExist' || type === 'disableParty' || type === 'notPermission') return;
    if (hasLogin) {
      // 判断 join party 是否是当前 用户的
      if (joinId) {
        this.checkGroup(moveParticipants, passWord, type);
      } else {
        if (this.$route.name === 'station') {
          this.$router.push({
            name: 'station'
          });
        } else {
          this.$router.push({
            name: 'joinOrStart'
          });
        }
      }
    } else {
      if (joinId) {
        if (!isMacWindows && !this.isWindows && (!this.isLinux || this.isAndroid) && !sessionStorage.getItem('enterPartyType')) {
          this.$router.push({
            name: 'joinParty',
            query: {
              join_id: joinId
            }
          });
          return;
        }
        if (this.participateChannelMode[this.CheckEnv.channelModel]) {
          // 跳转至对应的与会者页面
          if (moveParticipants) {
            this.$router.push({
              name: this.participateChannelMode[this.CheckEnv.channelModel] + 'Participate',
              query: {
                id: this.partyCode
              },
              params: {
                passWord
              }
            });
          } else {
            if (this.CheckEnv.deleteFlag == 1) {
              this.$router.push({
                name: 'remove',
                query: {
                  type: 'disableParty'
                }
              });
            } else if (this.CheckEnv.channelModel == 18) {
              this.$router.push({
                name: 'joinOrStart',
                query: {
                  model: 'station',
                  partyCode: this.partyCode
                }
              }); // station 页面需要登入
            } else {
              this.$router.push({
                name: 'preview',
                query: {
                  id: this.partyCode
                }
              });
            }
          }
        }
      } else {
        this.$router.push({
          name: 'joinOrStart'
        });
      }
    }
  },
  methods: {
    checkGroup(moveParticipants, passWord, type) {
      if (this.CheckEnv.channelModel == -1) {
        // -1代表partyCode不存在,未被创建过
        this.$message.error(this.$t('remainWords.enterId'));
        this.$router.push({
          name: 'joinOrStart'
        });
      }
      if (this.CheckEnv.deleteFlag == 1) {
        // 1代表partyCode被删除
        this.$router.push({
          name: 'remove',
          query: {
            type: 'disableParty'
          }
        });
      } else {
        if ((this.CheckEnv.owner || this.CheckEnv.coHost) && !this.asParticipants) {
          // 该party为登录者自己创建的party，跳转至host页面
          const routeName = this.channelMode[this.CheckEnv.channelModel];
          if (routeName) {
            this.$router.push({
              name: routeName,
              query: {
                id: this.partyCode
              }
            });
          }
        } else if (this.participateChannelMode[this.CheckEnv.channelModel]) {
          // 不是登录人的party，已与会者身份进入
          if (moveParticipants) {
            this.$router.push({
              name: this.participateChannelMode[this.CheckEnv.channelModel] + 'Participate',
              query: {
                id: this.partyCode
              },
              params: {
                passWord
              }
            });
          } else {
            if (this.model) {
              this.$router.push({
                name: 'station',
                query: {
                  id: this.partyCode
                }
              });
            } else {
              this.$router.push({
                name: 'preview',
                query: {
                  id: this.partyCode
                }
              });
            }
          }
        } else {
          this.$router.push({
            name: 'joinOrStart'
          });
        }
      }
    }
  }
};